<script setup lang="ts">
import { computed, ref } from "vue";
import type { ExerciseMcq } from "~/features/computer/data/exercises/exercise.types";
import { getMcqConceptLink } from "~/features/computer/data/mcq-links";

const props = defineProps<{
  question: ExerciseMcq;
}>();

const selected = ref<number | null>(null);
const isCorrect = computed(() => selected.value === props.question.correctIndex);
const conceptLink = computed(() => getMcqConceptLink(props.question));
</script>

<template>
  <div class="rounded-xl bg-white p-4 shadow-sm ring-1 ring-slate-200">
    <p class="text-sm font-semibold text-slate-900">{{ question.question }}</p>

    <div class="mt-3 space-y-2">
      <button
        v-for="(option, index) in question.options"
        :key="`${question.id}-${index}`"
        type="button"
        class="w-full rounded border px-3 py-2 text-left text-sm transition"
        :class="selected === null
          ? 'border-slate-200 bg-white text-slate-700'
          : index === question.correctIndex
            ? 'border-emerald-300 bg-emerald-50 text-emerald-800'
            : selected === index
              ? 'border-rose-300 bg-rose-50 text-rose-800'
              : 'border-slate-200 bg-white text-slate-500'"
        :disabled="selected !== null"
        @click="selected = index"
      >
        {{ option }}
      </button>
    </div>

    <div v-if="selected !== null" class="mt-3 rounded-lg bg-slate-50 p-3 text-sm">
      <p class="font-semibold" :class="isCorrect ? 'text-emerald-700' : 'text-rose-700'">
        {{ isCorrect ? 'Bilkul sahi' : 'Dobara socho' }}
      </p>
      <p class="mt-1 text-slate-700">{{ question.explanation }}</p>
      <NuxtLink
        v-if="conceptLink"
        :to="conceptLink"
        class="mt-2 inline-flex font-medium text-sky-700 underline decoration-sky-300 underline-offset-4 hover:text-sky-900"
      >
        Is topic ko samjho ->
      </NuxtLink>
    </div>
  </div>
</template>
